// extracted by mini-css-extract-plugin
export default {"wrapper":"AgentTransitionSeparator_wrapper__JAm4P","line":"AgentTransitionSeparator_line__G1-k0","transitionText":"AgentTransitionSeparator_transitionText__u78PI"};